import { useQuery } from '@tanstack/react-query';
import { normaliseArrayField } from '../utils/date-utils';

export const useCalendarData = (listingCalendarService) => {
  return useQuery({
    queryKey: ['calendarDates'],
    queryFn: async () => {
      const res = await listingCalendarService.unAuthGetReservation();
      const payload = res?.data ?? res ?? {};

      return {
        blockDates: normaliseArrayField(payload.blockDates),
        holidays: normaliseArrayField(payload.holidays),
        rangeStart: payload.rangeStart ?? null,
        rangeEnd: payload.rangeEnd ?? null,
      };
    },
    staleTime: 5 * 60 * 1000,    // 5 minutes
    cacheTime: 15 * 60 * 1000,   // 15 minutes
    refetchOnWindowFocus: false,
    retry: 1,
    keepPreviousData: true,
  });
};